/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createSlice } from "@reduxjs/toolkit";
import { publishingTargetState } from "./publishing-targets.state";
// import { Logger } from "../../../../cms/utils/log/logger";

const publishingTargets = createSlice({
    name: "publishingTargets",

    initialState: publishingTargetState,

    reducers: {
        setSelectedTarget (state, action) {
            const target = action.payload;
            // Logger.debug(`calling setSelectedTarget`, {target})
            state.selected = target;
        },
        setPublishingTargets (state, action) {
            const targets = action.payload;
            // Logger.debug("calling setPublishingTargets", { targets });
            state.targets = targets;
        },
        setPendingWebpageModifications (state, action) {
            const webpages = action.payload;
            // Logger.debug("calling setPendingModifications", { webpages });
            state.webpages = webpages;
            state.webpagesLoaded = true;
        },
        setPendingImageModifications (state, action) {
            const images = action.payload;
            // Logger.debug("calling setPendingImageModifications", { images });
            state.images = images;
            state.imagesLoaded = true;
        },
        setPendingDocumentModifications (state, action) {
            const documents = action.payload;
            // Logger.debug("calling setPendingDocumentModifications", { documents });
            state.documents = documents;
            state.documentsLoaded = true;
        },
    },
});

export const publishingTargetsReducer = publishingTargets.reducer;

export const {
    setSelectedTarget,
    setPublishingTargets,
    setPendingWebpageModifications,
    setPendingImageModifications,
    setPendingDocumentModifications,
} = publishingTargets.actions;
